import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconBandsintownStyle0 = cosmosIconCss;

const CosmosIconBandsintown$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconBandsintown extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '586cb22ab1356b2fe0448089b9c68da621b81689', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'b90cdd9f03492d1028e258d03bce767220d0f0a5', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'c570a6db38fd1030e2d3705fb6cf0a89cb0d11d6', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M4.5 17.88V4h2.69v11.346h7.632v-.743H7.958v-2.536h9.553v5.813H4.5ZM14.822 4h2.664v7.12h-2.664V4Zm-3.56 3.74h2.663v3.381h-2.664V7.739Zm-.716 0H7.882v3.381h2.664V7.739Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconBandsintownStyle0; }
}, [1, "cosmos-icon-bandsintown", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-bandsintown"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-bandsintown":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconBandsintown$1);
            }
            break;
    } });
}

const CosmosIconBandsintown = CosmosIconBandsintown$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconBandsintown, defineCustomElement };
